<template>
    <ModalFormCard class="lg:min-w-[800px] modal-default" 
        :action="'/actions/subscription-update-plan/' + subscription.id" 
        :submittedCallback="() => {
            $authSanctum.getUser(true)
            $emit('close')
            $event.$emit('modal-form-completed')
        }">
        <template #title>{{ options.change == 'upgrade' ? 'Upgrade' : 'Downgrade' }} {{ value.at_end_of_period ? 'end of period' : 'now' }}</template>

        <template #default="{ saving, errors }">
            <input type="hidden" name="_method" value="PUT" />
            <input type="hidden" name="time" :value="time" />

            <p class="font-semibold text-17" v-if="!confirmed">Current plan</p>

            <!-- <p class="text-14 pb-1 text-grey-900 mt-6">Plan</p>
            <div class='border border-grey-500 input-group h-12'>
                <p class="text-15 px-3 text-grey-800">{{ subscription.plan.name }}</p>
            </div> -->

            <SubscriptionBreakdown
                v-if="!confirmed"
                :plan="subscription.plan"
                :industry="subscription.company.industry"
                :area="subscription.location_area"
                :productId="subscription.product_id"
            />

            <p class="font-semibold text-17 mt-6">New plan</p>

            <Select
                selectClass="!bg-grey text-15"
                class="mt-4"
                menuClass="!bg-grey"
                name="plan_id"
                label="Plan"
                placeholder="Select a plan"
                v-model:value="value.plan_id"
                :options="planOptions"
                :disabled="saving || loadingPreview"
                @update:value="getPreview"
            />

            <!-- <input type="hidden" name="at_end_of_period" :value="value.at_end_of_period ? 1 : 0" />

            <InputCheckbox class="mt-4" @clicked="() => { value.at_end_of_period = !value.at_end_of_period; getPreview(); getPreview() }" :checked="value.at_end_of_period"
                v-if='!planChangeIsDowngrade'    
            >
                <p class="text-grey-900 text-14 pl-2">
                    {{ options.change == 'upgrade' ? 'Upgrade' : 'Downgrade' }} plan at the end of the current billing period, {{ $moment(subscription.current_ad_period.ads_period_to).format('Do MMMM YYYY') }}
                </p>
            </InputCheckbox> -->

            <template v-if="value.plan_id != null">
                <SubscriptionBreakdown
                    v-if="value.plan_id != null"
                    :plan="newPlan"
                    :industry="subscription.company.industry"
                    :area="subscription.location_area"
                    :productId="subscription.product_id"
                />
            </template>

            <!--  -->
            <template v-if="options.change != 'downgrade'">
                <p class="font-semibold text-17 mt-6">Upgrade schedule</p>

                <!-- subscription.stripe_trial_ends_at -->

                <Select
                    selectClass="!bg-grey text-15"
                    class="mt-4"
                    menuClass="!bg-grey"
                    name="at_end_of_period"
                    label="Preferred time"
                    v-model:value="value.at_end_of_period"
                    @update:value="() => { getPreview() }"
                    :disabled="saving || loadingPreview"
                    :options="[
                        { value: false, html: 'Upgrade now', disabled: subscription.stripe_trial_ends_at != null },  
                        { value: true, html: 'Upgrade end of period' },
                    ]"
                />

                <div v-if='subscription.stripe_trial_ends_at != null' class='text-14 text-grey-900 mt-2 flex items-center'>
                    <IconInfo class='stroke-grey-900 w-4.5 h-4.5' />
                    <p class='pl-2'>While you are in your first month you can only upgrade at the end of the period.</p>
                </div>
            </template>
            <template v-else>
                <input name='at_end_of_period' type='hidden' :value='value.at_end_of_period' />
            </template>

            <template v-if="value.plan_id != null && value.confirmed && preview != null">
                <div class='relative'>
                    <div class="absolute top-0 left-0 w-full h-full bg-white z-0 flex items-center justify-center" v-if='loadingPreview'>
                        <ClientOnly>
                            <Vue3Lottie :animationData="ZapoLogoJson" :height="100" :width="100" :loop="true" @onLoopComplete="onLoopComplete" />
                        </ClientOnly>
                    </div>

                    <p class="font-semibold text-17 mt-6">Payment breakdown</p>

                    <template v-if="preview != null">
                        <div class="flex items-center justify-between py-6 border-t border-grey-500 text-15 mt-6">
                            <p>{{ planChangeIsDowngrade ? 'Downgrade' : 'Upgrade' }} to {{ newPlan.name }}</p>
                            <p class="font-semibold">{{ $help.dp(planChangeIsDowngrade ? 0 : preview.sub_total) }}</p>
                        </div>

                        <div class="flex items-center justify-between py-6 border-t border-grey-500 text-15">
                            <p>VAT @ 20%</p>
                            <p class="font-semibold">{{ $help.dp(planChangeIsDowngrade ? 0 : preview.vat) }}</p>
                        </div>

                        <div class="flex items-center justify-between py-6 border-y border-grey-500 text-15">
                            <p>Today's charge</p>
                            <p class="font-semibold">{{ $help.dp(planChangeIsDowngrade ? 0 : preview.total) }}</p>
                        </div>
                    </template>

                    <p class="font-semibold text-15 mt-6">
                        You will {{ planChangeIsDowngrade ? 'downgrade' : 'upgrade' }} to {{ newPlan.name }} 
                        <template v-if="!value.now">on {{ $moment(subscription.ads_period_to).format('Do MMMM YYYY') }}</template>
                        <template v-else>immediately</template>
                    </p>

                    <p class="text-14 text-grey-900 mt-2">
                        Your billing date will remain the same and your payments will change to {{ $help.dp(newPlan.monthly_cost, 0) }}+VAT per month from the 
                        {{ $moment(subscription.ads_period_to).format('Do MMMM YYYY') }}.
                        <template v-if="value.at_end_of_period == 0">You will be charged {{ $help.dp(planChangeIsDowngrade ? 0 : preview.total) }} to upgrade today and receive an additional {{ $help.dp(preview.ad_spend) }} ad spend.</template>
                        <template v-else>You won’t be charged anything today.</template>
                    </p>
                
                </div>

                <!-- <Select
                    selectClass="!bg-grey text-15"
                    class="mt-4"
                    menuClass="!bg-grey"
                    name="card_id"
                    label="Select card"
                    placeholder="Select a card"
                    v-model:value="value.card_id"
                    :disabled="saving || loadingPreview"
                    :options="options.cards"
                    valueKey="id"
                    selectedCSS=""
                    @update:value="checkForAddNew"
                >
                    <template #option="{ option, selected }">
                        <div class="flex items-center w-full" v-if="option.html != 'Add new card'">
                            <PaymentMethodTable :paymentMethod="option" :table="false" />

                            <div class="flex items-center ml-4" v-if="option.default_payment_method != null">
                                <IconTrue class="stroke-white w-5 h-5 bg-black rounded-full" />

                                <p class="text-15 pl-2">Default</p>
                            </div>
                        </div>

                        <p v-else>{{ option.html }}</p>
                    </template>
                </Select> -->

                <SelectCard 
                    v-model:value="value.card_id"
                    :disabled="saving || loadingPreview"
                    :options="options.cards"
                    valueKey="id"
                    class="mt-4"
                    :lastModal="{
                        view: 'SubscriptionChangePlan',
                        editingModel: this.editingModel,
                        options: { ...this.options, currentValue: this.value },
                    }"
                />

                <InputCheckbox name="terms" class="mt-4" :disabled="saving || loadingPreview" v-if='!user.hasRole("zapo.employee")'>
                    <p class="text-grey-900 text-14 pl-2">
                        I agree to Zapo’s
                        <a href="https://www.zapo.com/privacy-policy" target="_blank" class="underline">Privacy Policy</a> and
                        <a href="https://www.zapo.com/terms-and-conditions" target="_blank" class="underline">Terms</a>
                    </p>
                </InputCheckbox>

                <input type='hidden' name='terms' value="1" v-else />
            </template>

            <div class="modal-buttons">
                <button
                    @click="() => { value.confirmed = true; getPreview() }"
                    :disabled="value.plan_id == null"
                    class="button-black default h-12"
                    v-if="!value.confirmed"
                    type="button"
                >
                    Next
                </button>

                <ButtonSaving class="button-black default h-12" v-if="value.confirmed" :disabled="saving || loadingPreview">
                    {{ planChangeIsDowngrade ? 'Downgrade' : 'Upgrade' }} subscription
                </ButtonSaving>

                <button class="button-purple default" type="button" @click="$emit('close')">Cancel</button>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Subscription from '~/models/subscription.js'
import PaymentMethod from '~/models/payment-method.js'
import Modal from '~/mixins/modal.js'
import SubscriptionBreakdown from '~/components/customer/blocks/subscription-breakdown-inline.vue'
import ZapoLogoJson from '~/assets/animation-zapo-loading.json'

export default {
    mixins: [Modal],

    data() {
        return {
            ZapoLogoJson,
            preview: null,
            time: null,
            loadingPreview: false,
            value: {
                plan_id: null,
                card_id: null,
                confirmed: false,
                at_end_of_period: false
            },
        }
    },

    created() {
        if (this.options.currentValue != null) {
            this.value = this.options.currentValue
        }

        if (this.options.cards != null && this.options.cards.length > 0) {
            this.value.card_id =
                this.subscription.stripe_payment_method_id != null
                        ? this.options.cards.find((c) => c.stripe_card_id == this.subscription.stripe_payment_method_id).id
                        : this.options.cards.find((c) => c.default_payment_method != null)?.id
        }

        if (this.subscription.stripe_trial_ends_at != null) {
            this.value.at_end_of_period = true;
        } else {
            this.value.at_end_of_period = this.options.change == 'downgrade' ? true : false
        }

        this.value.confirmed = false
        // this.getPreview()
    },

    methods: {
        checkForAddNew(a) {
            if (a !== 'add') {
                return
            }

            this.$event.$emit('modal-open', {
                view: 'PaymentMethodCreate',
                lastModal: {
                    view: 'SubscriptionChangePlan',
                    editingModel: this.editingModel,
                    options: { ...this.options, currentValue: this.value },
                },
            })
        },

        getPreview() {
            if (! this.value.confirmed) {
                return
            }

            this.loadingPreview = true;

            this.$axios
                .post('/actions/subscription-update-plan/' + this.subscription.id, {
                    plan_id: this.value.plan_id,
                    at_end_of_period: this.value.at_end_of_period
                })
                .then((res) => {
                    // console.log(res)
                    this.preview = res.preview
                    this.time = res.time

                    if (this.options.currentValue != null) {
                        this.value = this.options.currentValue
                    }

                    this.loadingPreview = false
                })
        },
    },

    computed: {
        subscription() {
            return this.editingModel
        },

        planOptions() {
            return this.options.plans
                .filter((p) => {
                    return this.subscription.product_id == p.product_id 
                        && (this.options.change == 'upgrade' ? p.id > this.subscription.currentPlanId() : p.id <= this.subscription.currentPlanId())
                })
                .map((l) => {
                    return {
                        value: l.id,
                        html: this.$help.capitalizeFirstLetter(l.name),
                        disabled: this.subscription.currentPlanId() == l.id,
                    }
                })
        },

        newPlan() {
            return this.options.plans.find((i) => i.id == this.value.plan_id)
        },

        planChangeIsDowngrade() {
            return this.newPlan && this.newPlan.monthly_cost < this.subscription.plan.monthly_cost
        },
    },

    components: {
        SubscriptionBreakdown,
    },
}
</script>
